(function (){
    'use strict';

    angular
        .module('elogbooks.admin.scd-imports')
        .config(registerRoutes);

    registerRoutes.$inject = ['$stateProvider', 'importsFilterDefaults'];

    function registerRoutes($stateProvider, importsFilterDefaults) {
        $stateProvider
            .state('dashboard.admin.scd-imports', {
                url: '/scd-imports',
                abstract: true,
                templateUrl: 'shared-templates/view.html',
                ncyBreadcrumb: {
                    label: '{{ ::"SCD_IMPORTS" | translate }}'
                },
                data: {
                    permissions: ['user_permission_manage_imports']
                }
            })
            .state('dashboard.admin.scd-imports.list', {
                url: '/scd-imports/list?page&limit&order&type&debug&status&filename&startDate&endDate&importedBy',
                parent: 'dashboard.admin.scd-imports',
                data: {
                    permissions: ['user_permission_manage_imports']
                },
                resolve: {
                    importsCollectionResponse: function (apiClient, rootResourceResponse, $stateParams) {
                        var params = angular.copy($stateParams);
                        const { status, debug, startDate, endDate } = $stateParams;

                        params = angular.extend({}, params, {
                            'status[]': status,
                            type: ['scd'],
                            debug: debug === 'all' ? null : debug,
                            startDate: startDate ?? null,
                            endDate: endDate ?? null,
                        });

                        if ($stateParams.importedBy) {
                            params.importedBy = JSON.parse($stateParams.importedBy).v;
                        }

                        return apiClient.get(rootResourceResponse.getLink('imports'), params);
                    },
                    userCollectionResponse: function (apiClient, rootResourceResponse) {
                        if (rootResourceResponse.getLink('users')) {
                            return apiClient.get(rootResourceResponse.getLink('users'), {
                                limit: 30,
                                order: 'name'
                            });
                        }

                        return null;
                    }
                },
                params: {
                    page: '1',
                    limit: '30',
                    type: 'all',
                    debug: 'all',
                    status: {array: true, value: importsFilterDefaults.defaultStatuses},
                    filename: null,
                    startDate: null,
                    endDate: null,
                    importedBy: null
                },
                views: {
                    '@dashboard': {
                        templateUrl: '/modules/common/imports/list/list.html',
                        controller : 'SCDImportListController',
                        controllerAs: 'vm',
                    }
                },
                ncyBreadcrumb: {
                    skip: true
                }
            })
            .state('dashboard.admin.scd-imports.list.details', {
                url: '/{importResource}/details?logsPage&logsLimit&logsOrder&logsType&logsMessage&logsCreateOptions&logsUpdateOptions&logsRow&logsKeyOptions',
                parent: 'dashboard.admin.scd-imports.list',
                data: {
                    permissions: ['user_permission_manage_imports']
                },
                views: parseBook({
                    'elogbooks-right@dashboard': {
                        templateUrl: '/modules/common/imports/details/details.html',
                        controller : 'ScdImportDetailsController',
                        controllerAs: 'vm'
                    }
                }),
                params: {
                    logsPage: '1',
                    logsLimit: '30',
                    logsType: null,
                    logsRow: null,
                    logsMessage: null,
                    logsCreateOptions: {array: true},
                    logsUpdateOptions: {array: true},
                    logsKeyOptions: {array: true}
                },
                resolve: {
                    importResponse: function (apiClient, $stateParams) {
                        return apiClient.get($stateParams.importResource.decode());
                    },
                    importLogsCollectionResponse: function (apiClient, importResponse, $stateParams) {
                        var params = {
                            page: $stateParams.logsPage,
                            limit: $stateParams.logsLimit,
                            type: $stateParams.logsType,
                            message: $stateParams.logsMessage,
                            'createOptions[]': $stateParams.logsCreateOptions,
                            'updateOptions[]': $stateParams.logsUpdateOptions,
                            'keyOptions[]': $stateParams.logsKeyOptions,
                            row: $stateParams.logsRow
                        };

                        return apiClient.get(importResponse.getLink('logs'), params);
                    },
                    importLogsUniqueKeysResponse: function (apiClient, importResponse) {
                        return apiClient.get(importResponse.getLink('logs-unique-keys'));
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"IMPORT_DETAILS_LIST" | translate }}'
                }
            })
            .state('dashboard.admin.scd-imports.list.new-scd-import', {
                url: '/new-scd-import',
                parent: 'dashboard.admin.scd-imports.list',
                data: {
                    permissions: ['user_permission_manage_imports']
                },
                views: {
                    '@dashboard': {
                        templateUrl: '/modules/admin/scd-imports/add/new-scd-import.html',
                        controller: 'SCDImportController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                },
                ncyBreadcrumb: {
                    skip: true
                }
            });
    }
})();
